export default __webpack_public_path__ + "static/media/star_apple.730f3dcd.png";